import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Global } from "../global";
import { Router } from "@angular/router";
import { Http, RequestOptions } from '@angular/http';
import { Headers } from '@angular/http';
import { AuthService } from "./auth/auth.service";
import Swal from "sweetalert2";

@Injectable()
export class ApiService {
  currentUser: any;
  headerOptions: any;
  headers = new Headers();
  constructor(
    private http: HttpClient,
    public global: Global,
    public router: Router,
    private http_: Http,
    private authService: AuthService,
  ) {

  }

  Get(path) {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.global.apiUrl}${path}`,
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Delete(path) {
    return new Promise((resolve, reject) => {
      this.http.delete(`${this.global.apiUrl}${path}`,
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Post(path, body) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.global.apiUrl}${path}`, JSON.stringify(body),
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }


  PostFormData(path, formData: FormData) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.global.apiUrl}${path}`, formData,
        {
          headers: new HttpHeaders()
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  PostImpresso(path, body) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.global.apiUrl}${path}`, JSON.stringify(body),
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {          
            resolve(res);
          },
          err => {            
            if (err.status == 200) {
              resolve(err.error.text);
            } else {
              reject(err);
            }
          }
        );
    });
  }
  
  GetFile(path: string) {    
  
    this.http.get(`${this.global.apiUrl}${path}`, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const downloadURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadURL;
        a.download = path.split('/').pop() || 'documento'; 
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(downloadURL);
      },
      error: (err) => {
        Swal.fire("Error", "Erro ao baixar arquivo", "error");
      }
    });
  }

  postFile(path, file: File) {
    let formData: FormData = new FormData();
    formData.append('uploadedFile', file);
    let headers = new Headers();

    headers.append('Accept', 'application/json');
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      this.http_.post(`${this.global.apiUrl}${path}`, formData, options)
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Put(path, body) {
    return new Promise((resolve, reject) => {
      this.http.put(`${this.global.apiUrl}${path}`, JSON.stringify(body),
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  AtivarDesativar(path, ativo) {
    return new Promise((resolve, reject) => {
      this.http.patch(`${this.global.apiUrl}${path}`, { "ativo": ativo },
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            //.set("Access-Control-Allow-Origin", "*")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Patch_body(path, body) {
    return new Promise((resolve, reject) => {
      this.http.patch(`${this.global.apiUrl}${path}`, JSON.stringify(body),
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  GetAnotherPath(apiUrl, path) {
    return new Promise((resolve, reject) => {
      this.http.get(`${apiUrl}${path}`,
        {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${this.authService.authToken.value}`)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

}
